function splitTextToCharacters(text) {
  return Array.from ? Array.from(text) : text.split("");
}
export { splitTextToCharacters };
